import FloatPopup from "./FLoatPopup";
import ContactUSForm from "./ContactUSForm";
import { fetchByJson } from "../api";
import { Button, message } from "antd";
import React, { useState } from "react";

const ContactUSPopup = (props) => {
  const ifShowContactUS = props.ifShowContactUS;
  const setIfShowContactUS = props.setIfShowContactUS;

  const [isSending, setIsSending] = useState(false);
  const [ifSend, setIfSend] = useState(false);

  const handleSned = async (info) => {
    setIsSending(true);
    try {
      const data = await fetchByJson("back/juku/contactus", {
        info: info,
      });

      setIsSending(false);
      if (data) {
        if (data.statusCode == 1) {
          message.success("表单已成功提交！感谢您的咨询！");
          setIfSend(true);
          // // 清空输入
          // setName("");
          // setJLPTLevel("");
          // setUniversity("");
          // setTargetUniversity("");
          // setContact("");
          // setMemo("");
        }
        if (data.statusCode == 0) {
          message.error(data.errorMessage);
        }
      } else {
        message.error("サーバーエラー");
      }
    } catch (error) {
      message.error("サーバーエラー");
    }
  };
  return (
    <div>
      <FloatPopup
        onMaskClick={() => {
          setIfShowContactUS(false);
        }}
        onClose={() => {
          setIfShowContactUS(false);
        }}
        visible={ifShowContactUS}
        width={400}
        positionOfMobile="top"
      >
        {ifSend ? (
          "表单已成功提交！感谢您的咨询！"
        ) : (
          <ContactUSForm handleSend={handleSned} isSending={isSending} />
        )}
      </FloatPopup>
    </div>
  );
};

export default ContactUSPopup;
